module.exports = __webpack_public_path__ + "img/38_51.1eee7f9c.png";